export const handleTestRegex = (patern: RegExp, value: string) => {
  let error = false;

  if (!patern.test(value)) {
    error = true;
  }

  return error;
};
